module.exports = "https://cdn-shared.mathletics.com/teacher-modules/teacher-class-management/205/assets/images/383b43b2dcc616b7f4206e5d826d86cc.svg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/icons/ico_actions_certs.svg
// module id = SAlD
// module chunks = 1